export default __webpack_public_path__ + "static/media/bg-halopagi.8f9538f2.png";